module.exports = "<input #input (change)=\"onChanged($event)\" (keydown)=\"onKeyDown($event)\" [(ngModel)]=\"qty\" />\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Grid/qtyEditor.component.html
// module id = 487
// module chunks = 1